import type { ContagemPergunta } from '../types';

interface Props {
  pergunta: ContagemPergunta;
  aoBaixar: (pergunta: ContagemPergunta) => void;
}

export default function CartaoContagem({ pergunta, aoBaixar }: Props) {
  return (
    <div className="rounded-lg border border-secondary-200 bg-white p-4">
      <div className="flex items-start justify-between gap-3">
        <h3 className="text-sm font-medium text-foreground-950">{pergunta.enunciado}</h3>
        <button
          type="button"
          onClick={() => aoBaixar(pergunta)}
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-secondary-300 bg-white px-2.5 py-1.5 text-xs font-medium text-foreground-800 transition-colors hover:bg-background-100"
        >
          <i className="ri-download-2-line text-sm" />
          Baixar
        </button>
      </div>

      <div className="mt-3 space-y-2.5">
        {pergunta.opcoes.map((opcao) => {
          const pct = Math.max(0, Math.min(100, Number(opcao.percentual) || 0));
          return (
            <div key={opcao.opcao}>
              <div className="flex items-baseline justify-between gap-2">
                <span className="min-w-0 truncate text-sm text-foreground-800">{opcao.opcao}</span>
                <span className="shrink-0 whitespace-nowrap text-xs text-secondary-500">
                  {Number(opcao.quantos)} · {pct.toLocaleString('pt-BR')}%
                </span>
              </div>
              <div className="mt-1 h-2 w-full overflow-hidden rounded-full bg-secondary-100">
                <div
                  className="h-2 rounded-full bg-primary-500"
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}